<template>
    <div :class="{ 'flow-list-item': true, 'round-corner': true, handle: checked }">
        <div
            :class="{ 'check-box': true, checked: ids.indexOf(item.id) != -1 }"
            v-if="checked"
            @click="checkHandle(item.id)"
        ></div>
        <PanelNewUi
            v-if="item"
            :img="getAvatarByUUID(item.starterUUID)"
            :item="item"
            :title="item.title"
            :tagArr="tagArr"
            :descArr="descArr"
            :btnArr="btnArr"
            :foldDesc="true"
            @btnDetailClick="btnDetailClickHandler"
            @btnDeleteClick="btnDeleteClickHandler"
            @btnRecodeClick="btnRecodeClickHandler"
        />
    </div>
</template>

<script>
    import { Toast, Dialog, Checkbox, Sidebar } from "vant"
    import { formatFieldsForFlow } from "@/utils/dateTimeUtil"
    import PanelNewUi from "@/components/Panel/PanelNewUi"
    import { deleteInstance } from "@/api/flow"
    import { getAvatarByUUID } from "@/utils/commons"
    import { locationTo, complete } from "@/utils/url"
    import http from "@/utils/http"
    import {sysVariable} from "@/utils/sys-variable"

    export default {
        name: "FlowListItem",
        components: {
            PanelNewUi,
            [Checkbox.name]: Checkbox,
        },
        props: ["type", "item", "checked", "ids"],
        data() {
            return {
              makeCopyHandRead: false,
              makeCopy:0,
              appraiseOn:""
            }
        },
        computed: {
            tagArr() {
                let result = {}
                switch (this.item.tStatus) {
                    case "end":
                        result.text = "已办结"
                        result.color = "#666"
                        break
                    case "send":
                        result.text = "进行中"
                        result.color = "#00A742"
                        break
                    case "finish":
                        result.text = "已中止"
                        result.color = "#4F4A81"
                        break
                    case "back":
                        result.text = "已退回"
                        result.color = "#ef4f4f"
                        break
                    case "draft":
                        result.text = "草稿"
                        result.color = "#deb887"
                        break
                    case "revoke":
                    case "haverevoke":
                        result.text = "已撤销"
                        result.color = "#947286"
                        break
                    case "temporary":
                        result.text = "已暂缓"
                        result.color = "#d4652b"
                        break
                }
                return [result]
            },
            descArr() {
                let descArr = []

                // 发起人和发起时间
                // descArr.push({ key: "", value: `${this.item.starterName}发起于${this.item.startTime}` })

                // 操作人/操作时间/当前操作环节
                if (this.item.lastOperName) descArr.push({ key: "最新操作人", value: this.item.lastOperName })
                if (this.item.opdate) descArr.push({ key: "最新操作时间", value: this.item.opdate })
                if (this.item.curNodeName) descArr.push({ key: "当前所在环节", value: this.item.curNodeName })

                // 表单数据
                if (this.item.wfContent) {
                    try {
                        let fieldArr = JSON.parse(this.item.wfContent)
                        fieldArr = formatFieldsForFlow(fieldArr)
                        fieldArr.forEach(field => descArr.push({ key: field.cnfield, value: field.value }))
                    } catch (e) {
                        console.warn(e)
                    }
                }

                return descArr
            },
            btnArr() {
                let btnArr = []

              // 查看详情
              btnArr.push({ text: "查看详情", event: "btnDetailClick" })

              // 2023-10-23 好差评 添加评价按钮
              if(this.appraiseOn == 'true') {
                if (this.item.tStatus == 'end' || this.item.tStatus == 'send') {
                  btnArr.push({text: '评价', event: 'btnRecodeClick'})
                }
              }
                // 删除事项
                if (
                    /^(ongoing|end|draft)$/.test(this.type) &&
                    /^(finish|revoke|haverevoke|back|draft)$/.test(this.item.tStatus)
                ) {
                    btnArr.push({ text: "删除", event: "btnDeleteClick" })
                }

                return btnArr
            },
        },
        mounted() {
          this.getSysParam()
          // 2023-10-23 好差评 系统参数中获取好差评开关及好差评Path
          sysVariable('appraiseOn')
              .then(resp => {
                this.appraiseOn = resp
              })
          sysVariable('appraisePath')
              .then(resp => {
                this.appraisePath = resp
              })
        },
        methods: {
            checkHandle(id) {
                this.$emit("itemCheck", id)
            },
            btnDetailClickHandler() {
                //保存类型的草稿
                if (this.item.tStatus == "draft" && this.item.tType == "pub") {
                    let index = window.location.href.lastIndexOf("draft") + 6
                    let keyText = window.location.href.substr(index)
                    this.locationTo(`weixin/weui/cooperate.html#new/form/draft/${keyText}/${this.item.id}`)
                }
                //取回类型的草稿
                else if (this.item.tStatus == "draft") {
                    this.locationTo(`weixin/weui/cooperate.html#detail/${this.item.id}` + "/draft")
                } else {
                  //获取url中的最后一个参数
                    // let index = window.location.href.lastIndexOf("/") + 1
                    // let keyText = window.location.href.substr(index)
                    // let read = this.item.read;
                    // console.log(read);
                  // true: 1  显示按钮, false: 0 不显示按钮
                  //如果this.makeCopyHandRead为true,则显示按钮
                  if(this.makeCopyHandRead) {
                    console.log(this.makeCopyHandRead === 'true');
                    if(this.makeCopyHandRead === 'true') {
                        this.makeCopy = 1
                    } else {
                        this.makeCopy = 0
                    }
                    //获取url中的最后一个参数
                    let index = window.location.href.lastIndexOf("/") + 1
                    let code = window.location.href.substr(index)
                    console.log(code);
                    if(this.item.todo == "todo") {
                        console.log(this.item.todo);
                        this.locationTo(`weixin/weui/cooperate.html#detail/${this.item.id}/?todo=${this.item.todo}/?code=${code}`)
                    } else {
                        this.locationTo(`weixin/weui/cooperate.html#detail/${this.item.id}/?code=${code}`)
                    }
                  } else {
                    this.locationTo(`weixin/weui/cooperate.html#detail/${this.item.id}`)
                  }
                }
            },
            btnDeleteClickHandler() {
                Dialog.confirm({ message: "确定要删除这个事项吗？" }).then(() => {
                    deleteInstance(this.item.id).then(res => {
                        if (res.code == 200) {
                            this.$emit("deleteHandler", this.item.id)
                            Toast(res.msg || "删除成功")
                        } else {
                            Toast(res.msg || "删除失败")
                        }
                    })
                })
            },
          // 2023-10-23 好差评 评价按钮点击事件
          btnRecodeClickHandler() {
            var ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger" || ua.match(/wxwork/i) == "wxwork") {
              this.channel = 2
            } else if (ua.match(/welink/i) == "welink" || ua.match(/anyoffice/i) == "anyoffice"){
              this.channel = 4
            } else if (ua.match(/dingtalk/i) == "dingtalk"){
              this.channel = 3
            } else {
              this.channel = 1
            }
            let stage = this.item.tStatus == 'send'? 1 : 2;
            let serviceId = this.item.wfInfoId;
            let instId = this.item.id;
            location.href = this.appraisePath + `/pingjia/h5#/pages/evaluation/evaluation?channel=${this.channel}&stage=${stage}&serviceId=${serviceId}&instId=${instId}`
          },
            getAvatarByUUID,
            locationTo,
            complete,
            //获取系统参数
            getSysParam() {
                const keys = [
                    "makeCopyHandRead", //部门类别
                ]
                http.get("/param/keys.htm", { keys: keys.join() }).then(resp => {
                    if (!resp || resp.code != 200) {
                        Toast({
                            message: `获取系统参数${dictionaryKey}失败`,
                            className: "zindex",
                        })
                    } else {
                        let data = resp.data
                        this.makeCopyHandRead = data.makeCopyHandRead
                    }
                })
            },
        },
    }
</script>

<style scoped lang="scss">
    .flow-list-item {
        &.handle {
            padding-left: 30px;
            position: relative;
        }
        .check-box {
            display: block;
            box-sizing: border-box;
            width: 20px;
            height: 20px;
            color: transparent;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
            border: 1px solid var(--main-color);
            transition-duration: var(--main-color);
            transition-property: color, border-color, background-color;
            border-radius: 10px;
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -10px;
            &.checked {
                background: var(--main-color);
                &:before {
                    content: "";
                    display: inline-block;
                    width: 12px;
                    height: 6px;
                    border-left: 1px solid #ffffff;
                    border-bottom: 1px solid #ffffff;
                    position: absolute;
                    top: 3px;
                    left: 3px;
                    transform: rotate(-45deg);
                }
            }
        }
    }
</style>
